import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';

import { BulkResumeUploadComponent } from './bulk-resume-upload.component';
import { BulkUploadResumeActionsComponent } from './bulk-upload-resume-actions/bulk-upload-resume-actions.component';
import { BulkUploadStatusComponent } from './bulk-upload-status/bulk-upload-status.component';

@NgModule({
  declarations: [
    BulkResumeUploadComponent,
    BulkUploadResumeActionsComponent,
    BulkUploadStatusComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule
  ],
  exports: [
    BulkResumeUploadComponent,
    BulkUploadResumeActionsComponent,
    BulkUploadStatusComponent
  ],
  entryComponents: [BulkResumeUploadComponent, BulkUploadResumeActionsComponent]
})
export class BulkResumeUploadModule { }

